import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy deep link. The student chat is now a single search-param-driven
 * workspace (`/client/chat?chat=<id>`), so any old `/client/chat/$chatId` link
 * (bookmarks, notifications) redirects into it with the chat pre-selected.
 */
export const Route = createFileRoute('/client/chat/$chatId')({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/client/chat', search: { chat: params.chatId } });
  },
});
